export interface IMeetingDetail {
  // 企业id
  companyId: string;
  // 会议id
  meetingNo: string;
  // 会议主题
  subject: string;
  // 会议描述
  content: string;
  // 会议开始时间
  beginTime: number;
  // 会议结束时间
  endTime: number;
  // 房间订单列表
  roomOrderList: IRoomOrder[];
  // 用户输入的地址
  address: string;
  // 主持用户id
  organizerUserId: string;
  // 主持用户名
  displayUserName: string;
  // 组织者员工id
  organizerStaffId: string;
  // 会议状态
  status: MeetingState;
  /** 会议范围：1-商务洽谈（外部），2-问题与决策（评审、讨论等），3-例行会议（周总、月总等），; 4-其他（培训、访谈等），5-长期占用，6-自定义 */
  scope: 1 | 2 | 3 | 4 | 5 | 6;
  // 是否公开
  isPublic: number;
  // 是否需要审批
  isAudit: boolean;
  // 创建时间
  createdDate: number;
  // 提醒标识，用于定时发送会议提醒
  noticeLabels: string[];
  // 从上次用户浏览会议记录时间到当前的变更记录
  changeLogs: any[];
  // 周期会议Id
  repeatMeetingNo: string;
  // 是否为周期会议
  isRepeatMeeting: boolean;

  meetingAllocationViews: {
    meetingNo: string;
    // 1:迈玲。2：腾讯。3：钉钉。4:飞书。5：企微。6：outLook
    meetingTypes: number[];
    // 入会密码
    password: string;
    // 是否开启录制,默认值false
    recording: boolean;
    // 终端入会静音,默认值false
    muteNewParticipant: boolean;
    // 会议最大带宽,0代表没设置的默认值。可设置项为：64, 96, 128, 256, 384, 512, 768, 832, 1024,1280, 1920, 2048, 2560, 3072, 3684, 4096。默认值:0
    maxBandwidth: number;
  };
  // 与会人员
  members: IMembers[];
  // 会议审核记录视图列表
  meetingAuditRecordViewList: IMeetingAuditRecordView[];
  thirdPartyMeetingViewList: IMeetingThirdParty[];
  // 会议标志视图
  meetingSignView: {
    // 会议室签到状态 未开始签到:0，完成签到:1
    signStatus: number;
    // 是否可以签到
    isCanSign: boolean;
  };
  // 会议文件夹视图
  meetingFolderViews: IMeetingFile[];
}

export interface IRoomOrder {
  // 预约号
  orderNo: string;
  // 会议室id
  roomId: string;
  // 会议开始时间
  startTime: number;
  // 会议结束时间
  endTime: number;
  // 会议描述
  description: string;
  // 地址
  address: string;
}

export enum MeetingState {
  // 会前
  BEFORE = 'BEFORE',
  // 会中
  DURING = 'DURING',
  // 取消
  CANCEL = 'CANCEL',
  // 结束
  FINISH = 'FINISH',
  // 归档
  FILED = 'FILED',
  // 审批中
  AUDITING = 'AUDITING',
  // 审核拒绝
  AUDIT_REJECT = 'AUDIT_REJECT',
  // 审核撤销
  AUDIT_REVOKE = 'AUDIT_REVOKE',
  // 审核过期
  AUDIT_EXPIRE = 'AUDIT_EXPIRE'
}

export interface IMembers {
  // 邀请者
  invitor: IMember;
  // 与会者
  user: IMember;
  // 会议号
  meeting: string;
  // 重复会议
  repeatMeeting: string;
  // 加入会议的时间
  createTime: number;
  // 修改时间
  updateTime: number;
  // 与会人员当前的状态 0:待回复,1:拒绝,2:参加,3:请假
  state: number;
  // 添加来源
  from: number;
  // 会议备注
  remark: string;
  // 语音提醒状态, 0:未提醒,1:已提醒
  voiceRemindStatus: number;
  // 关系
  relationship: {
    // 关系. 1:互为联系人, 2:单向添加，3:未添加
    relation: 1 | 2 | 3;
    // 是否是同事
    commonCompany: boolean;
  };
}

export interface IMember {
  // 用户id
  _id: string;
  // 账号系统id（暂时用不上）
  systemId: string;
  // 员工id
  staffId: string;
  // 部门
  department: string;
  // 企业名称
  company: string;
  // 企业id
  companyId: string;
  // 邮箱
  email: string;
  // 手机号
  mobile: string;
  // 头像
  avatar: string;
  // 昵称
  displayName: string;
  // 用户在企业的真实名称
  realName: string;
  // 备注
  remark: string;
  // 职位
  jobTitle: string;
}

export enum MeetingAuditRecordStatus {
  // 审批中
  AUDITING = 'AUDITING',
  // 已通过
  AGREE = 'AGREE',
  // 不通过
  REFUSE = 'REFUSE',
  // 已过期
  EXPIRED = 'EXPIRED',
  // 已撤销
  REVOKED = 'REVOKED'
}

export interface IMeetingAuditRecordView {
  // 审批记录id
  id: string;
  // 公司标识
  companyId: string;
  // 审批状态
  status: MeetingAuditRecordStatus;
  // 最终审批人
  lastAuditor: IAuditor;
  // 最后审批人日期
  lastAuditDate: string;
  // 可审批人员工列表
  auditorList: IAuditor[];
  // 会议室id
  roomId: string;
  // 会议室名字,有包含区域
  address: string;
  // 会议室日程
  orderNo: string;
  // 会议编号
  meetingNo: string;
  // 申请理由
  reason: string;
  // 拒绝理由
  refuseReason: string;
}

export interface IAuditor {
  companyId: string;
  staffId: string;
  realName: string;
  // 部门最后一级
  departmentLastLevel: string;
  // 会议审批记录id
  meetingAuditRecordId: string;
  // 是否已读
  isRead: boolean;
}

export interface IMeetingFile {
  // 文件id
  id: string;
  // 会议
  meetingNo: string;
  fileKey: string;
  fileName: string;
  contentType: string;
  size: number;
  url: string;
}

export enum IsPublic {
  private = 0,
  public = 1
}

export enum MeetingAuditStatus {
  /** 审批中 */
  AUDITING = 'AUDITING',
  /** 同意 */
  AGREE = 'AGREE',
  /** 拒绝 */
  REFUSE = 'REFUSE',
  /** 过期 */
  EXPIRED = 'EXPIRED',
  /** 撤销 */
  REVOKED = 'REVOKED'
}

export enum MeetingRemind {
  'on_time' = 'on_time',
  'before_5' = 'before_5',
  'before_10' = 'before_10',
  'before_15' = 'before_15',
  'before_20' = 'before_20',
  'before_30' = 'before_30',
  'none' = 'none'
}

export interface IMeetingThirdParty {
  meetingId: string;
  userId?: string;
  accessNumber: string;
  // 线上会议平台
  emailDisplayName: string;
  oem: boolean;
  displayLength: number;
  joinUrl: string;
  liveUrl: string;
  hostUrl: string;
  hostPassword: string;
  passcode: string;
  // 电话拨号
  telAccessNumber: string;
}

export enum MeetingOptionType {
  // 操作周期会议中的本次会议
  ThisMeeting='ThisMeeting',
  // 操作周期会议中的本次会议及之后的会议
  PartMeeting='PartMeeting',
  // 操作周期会议中的所有会议
  AllMeeting='AllMeeting',
  // 操作单次会议
  SingleMeeting='SingleMeeting',
}
